package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.PermissionType
import kotlinx.serialization.Serializable

@Serializable
enum class UserPermissionMedicalRecord(private val literal: String) : PermissionType {
	添加医案("添加医案"),
	添加私有医案("添加私有医案");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "user_permission_medical_record"}
	override fun getLiteral(): String {return literal}
}
